import type { ButtonProps } from "@mui/material";
import classNames from "classnames";
import type { FC } from "react";
import { useTranslation } from "react-i18next";
import { AppButton } from "../../../../../shared/components/AppButton";
import { SparksIcon } from "../../../../../shared/icons/SparksIcon";
import type { SidebarModalsType } from "../../../types";
import styles from "../styles.module.css";

interface Props extends ButtonProps {
  openAskGPT: (type: SidebarModalsType) => void;
}

export const AskGPTButton: FC<Props> = ({ openAskGPT, ...props }) => {
  const { t } = useTranslation();
  return (
    <AppButton
      buttonType={"text"}
      onClick={() => openAskGPT("askGpt")}
      icon={<SparksIcon />}
      className={classNames(styles.button, styles["ask-gpt-button"])}
      {...props}
    >
      {t("sidebar.ask_gpt_button")}
    </AppButton>
  );
};
